import { ReactNode } from 'react';
import { ColumnDef } from '#/components/UnifiedRfqs/BottomTableRow';

interface ColumnProps {
  readonly time: ReactNode;
  readonly auction: ReactNode;
  readonly product: ReactNode;
  readonly description: ReactNode;
  readonly actions: ReactNode;
  readonly quote: ReactNode;
  readonly completed: ReactNode;
  readonly remaining: ReactNode;
  readonly oid: ReactNode;
  readonly account: ReactNode;
  readonly date: ReactNode;
  readonly qty?: string;
  readonly price?: string;
  readonly side?: ReactNode;
}
export default function makeColumns({
  time,
  auction,
  product,
  description,
  actions,
  quote,
  qty,
  price,
  side,
  completed,
  remaining,
  oid,
  account,
  date,
}: Partial<ColumnProps> = {}): ColumnDef[] {
  return [
    {
      id: 'date',
      name: 'Date',
      children: date,
    },
    {
      id: 'time',
      name: 'Time',
      children: time,
      mobileOptions: {
        isMainRow: true,
      },
    },
    {
      id: 'auction',
      name: 'Auction',
      children: auction,
      mobileOptions: {
        isMainRow: true,
      },
    },
    {
      id: 'product',
      name: 'Product',
      children: product,
    },
    {
      id: 'description',
      name: 'Description',
      children: description,
      mobileOptions: {
        isMainRow: true,
      },
    },
    {
      id: 'actions',
      name: 'Actions',
      children: actions,
      mobileOptions: {
        hideLabel: true,
      },
    },
    {
      id: 'quote',
      name: 'Quote',
      children: quote,
      mobileOptions: {
        isHidden: true,
      },
    },
    {
      id: 'qty',
      name: 'Qty',
      children: qty,
      desktopOptions: {
        isHidden: true,
      },
    },
    {
      id: 'price',
      name: 'Price',
      children: price,
      desktopOptions: {
        isHidden: true,
      },
    },
    {
      id: 'side',
      name: 'Side',
      children: side,
      desktopOptions: {
        isHidden: true,
      },
    },
    {
      id: 'completed',
      name: 'Completed',
      children: completed,
    },
    {
      id: 'remaining',
      name: 'Remaining',
      children: remaining,
    },
    {
      id: 'oid',
      name: 'Order ID',
      children: oid,
    },
    {
      id: 'account',
      name: 'Account',
      children: account,
    },
  ];
}
